module.exports = __webpack_public_path__ + "8bf27e6ac138d014e81f19aed28c11c3.png";